import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable";
import "bootstrap-daterangepicker/daterangepicker.css";
import { leadsData } from "../../core/data/json/leads";
import { Modal } from "react-bootstrap";
import { TableData } from "../../core/data/interface";
import CollapseHeader from "../../core/common/collapse-header";
import { all_routes } from "../router/all_routes";
const Clients = () => {
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      width:"90px",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width:'132px',
        sorter: (a: TableData, b: TableData) =>
          a.company_name.length - b.company_name.length,
      },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      width:'132px',
      render: (text: any) => (
        <Link to={route.leadsactivity} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.lead_name.length - b.lead_name.length,
    },
    {
      title: "API Key",
      dataIndex: "apikey",
      key: "api",
      width: "392px",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },

    {
        title: "Status",
        dataIndex: "status",
        width: "90px",
        render: (text: string) => (
          <div>
            {text === "Closed" && (
              <span className="badge badge-pill badge-status bg-success">
                {text}
              </span>
            )}
            {text === "Connected" && (
              <span className="badge badge-pill badge-status bg-warning">
                {text}
              </span>
            )}
            {text === "Lost" && (
              <span className="badge badge-pill badge-status bg-danger">
                {text}
              </span>
            )}
            {text === "Not connected" && (
              <span className="badge badge-pill badge-status bg-pending">
                {text}
              </span>
            )}
          </div>
        ),
        sorter: true,
      },
    {
      title: "Action",
      dataIndex: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to={route.clientsedits}
                // data-bs-toggle="modal"
                //  data-bs-target="#edit_ip"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_lead"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>

            <Link className="dropdown-item" to="#">
              <i className="ti ti-clipboard-copy text-blue-light" /> clone
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                      Clients<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                         
                          <Link
                            to="#"
                            className="btn btn-primary"
                             data-bs-target="#offcanvas_add"
                          data-bs-toggle="offcanvas"
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Clients
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                 
                    {/* Contact List */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={data} columns={columns} />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        {/* Add Company */}
        <div
        className="offcanvas  "
        style={{ width: "1250px", right: "0", top: "0" }}
        tabIndex={-1}
        id="offcanvas_add"
      >
          <div className="offcanvas-header border-bottom"  >
            <h5 className="fw-semibold">Add New Clients</h5>
            <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row align-items-center">
               

                <div className="col-md-6">
                  <div className="form-group ">
                    <label className="form-label">Name </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group ">
                    <label className="form-label">Building/Street</label>
                    <div className="input-group mb-3">
                    <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                    <input type="text" className="form-control" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
               

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Area/State/Zipcode </label>
                   <div className="input-group mb-3">
                     <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <input type="text" className="form-control" />
                   </div>
                 </div>
               </div>

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Trunk</label>
                   <div className="input-group mb-3">
                   <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                   <input type="text" className="form-control" />
                   </div>
                 </div>
               </div>
             </div>
             <div className="row align-items-center">
               

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Server Allotted</label>
                   <div className="input-group mb-3">
                     <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <input type="text" className="form-control" />
                   </div>
                 </div>
               </div>

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Enable 2FA</label>
                   <div className="input-group mb-3">
                   <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <select id="multiple_labels" className="form-select">
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                 
                  </select>
                   </div>
                 </div>
               </div>
             </div>
             <div className="row align-items-center">
               

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">API Token</label>
                   <div className="input-group mb-3">
                     <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <input type="text" className="form-control" />
                   </div>
                 </div>
               </div>

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Enable MCA CRM</label>
                   <div className="input-group mb-3">
                   <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <select id="multiple_labels" className="form-select">
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                 
                  </select>
                   </div>
                 </div>
               </div>
             </div>
             <div className="row align-items-center">
               

               <div className="col-md-6">
                 <div className="form-group ">
                   <label className="form-label">Status</label>
                   <div className="input-group mb-3">
                     <span className="input-group-text ">
                       <i className="ti-user"></i>
                     </span>
                     <select id="multiple_labels" className="form-select">
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                 
                  </select>
                   </div>
                 </div>
               </div>
               </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenModal2(true)}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add Company */}

      </>
    </>
  );
};

export default Clients;